import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
export function OfferCTA() {
  return <Section id="offer" theme="black" className="text-center relative overflow-hidden border-b border-gold-hairline" data-id="element-99">
      {/* Decorative background element */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#C9A24B 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-100"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-101">
        <h2 className="text-3xl md:text-5xl font-serif font-medium mb-8 text-bone leading-tight" data-id="element-102">
          You can keep paying for your landlord's next vacation...
        </h2>

        <p className="text-xl md:text-2xl text-bone-muted font-sans mb-16" data-id="element-103">
          Or you can spend less than the price of a fast-food meal to unlock the
          backdoor to homeownership.
        </p>

        <div className="bg-onyx p-1 md:p-2 shadow-editorial-dark mb-8 mx-auto max-w-2xl" data-id="element-104">
          <div className="border border-gold-hairline p-10 md:p-14" data-id="element-105">
            {/* Ornamental Divider */}
            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-106">
              <div className="h-[1px] w-12 bg-gold/30" data-id="element-107"></div>
              <div className="w-2 h-2 rotate-45 border border-gold/50" data-id="element-108"></div>
              <div className="h-[1px] w-12 bg-gold/30" data-id="element-109"></div>
            </div>

            <div className="text-xs font-semibold tracking-[0.2em] text-gold uppercase mb-8" data-id="element-110">
              The Ultimate Auction Secrets Blueprint 2026
            </div>

            <div className="flex justify-center items-start mb-12" data-id="element-111">
              <span className="text-3xl font-serif text-gold-light mt-2" data-id="element-112">
                $
              </span>
              <span className="text-7xl md:text-8xl font-serif font-semibold text-gold-light tracking-tighter" data-id="element-113">
                6.36
              </span>
            </div>

            <Button fullWidth className="md:w-auto md:px-12 py-5 text-xl mb-8" data-id="element-114">
              Get The Blueprint Now
            </Button>

            <div className="flex flex-col items-center gap-3" data-id="element-115">
              <div className="text-bone-muted text-sm flex items-center gap-2" data-id="element-116">
                <svg className="w-4 h-4 text-gold-soft" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-117">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-118"></path>
                </svg>
                Instant PDF Download
              </div>
              <div className="text-bone-muted/50 text-xs" data-id="element-119">
                Start your National Scan in the next 5 minutes.
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}